import React, { useState, useEffect, useRef } from 'react';
import './MyAccount.css';
import AccountInformation from './components/AccountInformation/AccountInformation';
import SecurityInfo from './components/SecurityInfo/SecurityInfo';
import InvoiceDelivery from './InvoiceDelivery/InvoiceDelivery';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';

const MyAccount = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('MyAccount - Received paymentScenario:', paymentScenario);

  // Use constants instead of hardcoded logic
  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  console.log('MyAccount activeData:', activeData);
  console.log('MyAccount scenarioPrefix:', scenarioPrefix);

  // State for toggles - matching Dashboard pattern
  const [toggles, setToggles] = useState({
    accountInfo: true,
    additionalContact: true, 
    securityInfo: true,
    invoiceDelivery: true,
  });

  const [templates, setTemplates] = useState([]);
  const [blockStates, setBlockStates] = useState({});
  const [supportBlockStates, setSupportBlockStates] = useState({});
  const triggerSaveData = useRef(false);
  const [reloadTemplates, setReloadTemplates] = useState(false);

  // Template name logic with scenario prefix - matching Dashboard pattern
  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-myAccount' 
    : `gardenwall-myAccount-${scenarioPrefix}`;
    
  console.log('MyAccount Template name:', template_name);

  const handleBlockStatesChange = (newBlockStates) => {
    setBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  const handleSupportBlockStatesChange = (newBlockStates) => {
    setSupportBlockStates(newBlockStates);
    triggerSaveData.current = true;
  };

  // Function to toggle on/off switches - matching Dashboard
  const handleToggle = (section) => {
    setToggles((prev) => ({ ...prev, [section]: !prev[section] }));
    triggerSaveData.current = true;
  };

  // Auto-save trigger - matching Dashboard pattern
  useEffect(() => {
    if (triggerSaveData.current) {
      saveData();
      triggerSaveData.current = false;
    }
  }, [toggles, blockStates, supportBlockStates]);

  // Fetch templates function - matching Dashboard
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount - matching Dashboard
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates);
    };

    loadTemplates();
  }, []);

  // Reload templates effect - matching Dashboard
  useEffect(() => {
    if (reloadTemplates) {
      const loadTemplates = async () => {
        const fetchedTemplates = await fetchTemplates();
        setTemplates(fetchedTemplates);
        setReloadTemplates(false);
      };
  
      loadTemplates();
    }
  }, [reloadTemplates]);

  // Apply template data when templates are loaded - matching Dashboard
  useEffect(() => {
    if (templates && templates.length > 0) {
      console.log('MyAccount Templates updated:', templates);
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate) {
        try {
          const template_data = JSON.parse(
            JSON.parse(specificTemplate.template)
          );
          setToggles(template_data.toggles || {
            accountInfo: true,
            additionalContact: true, 
            securityInfo: true,
            invoiceDelivery: true,
          });
          setBlockStates(template_data.blockStates || {});
          setSupportBlockStates(template_data.supportBlockStates || {});
        } catch (error) {
          console.error('Error parsing template data:', error);
        }
      } else {
        console.log('MyAccount specific template not found');
      }
    }
  }, [templates, template_name]);

  // Save data function - matching Dashboard pattern
  const saveData = async () => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles,
        blockStates,
        supportBlockStates,
        scenarioData: paymentScenario
      })
    );
    
    console.log('MyAccount - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    if (templates && templates.length > 0) {
      const specificTemplate = templates.find(
        (template) => template.template_name === template_name
      );
      if (specificTemplate && specificTemplate.id) {
        url = `${urlBase}/update/${specificTemplate.id}`;
        method = 'put';
      }
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('MyAccount Response Data:', response.data); 
      if (method === 'post') {
        setReloadTemplates(true);
      }

    } catch (error) {
      console.error('Error saving myAccount template:', error);
    }
  };

  return (
    <div className="my-account">
      <h1 className="my-account-header">
        My Account – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
      </h1>
  
      <div className="garden-wall-normal-card">
        <div>
          <div className="my-account-name">
            Hi, Herman
          </div>
          <div className="description">
            Manage your contact info, password, and security etc.
          </div>
        </div>
  
        <div className="my-account-card-wrap">
          <AccountInformation
            hidden={!toggles.accountInfo}
            checked={toggles.accountInfo}
            onChange={() => handleToggle('accountInfo')}
            additionalChecked={toggles.additionalContact}
            onAdditionalChange={() => handleToggle('additionalContact')}
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          />
  
          <SecurityInfo 
            hidden={!toggles.securityInfo}
            checked={toggles.securityInfo}
            onChange={() => handleToggle('securityInfo')}
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          />
         
          <InvoiceDelivery 
            hidden={!toggles.invoiceDelivery}
            checked={toggles.invoiceDelivery}
            onChange={() => handleToggle('invoiceDelivery')}
            scenarioData={paymentScenario}
            onBlockStatesChange={handleBlockStatesChange}
            blockStates={blockStates}
          />
        </div>
      </div>
    </div>
  );
  
};

export default MyAccount;

